import {
  List,
  Datagrid,
  TextField,
  NumberField,
  TopToolbar,
  CreateButton,
  useGetIdentity,
  EditButton,
  DeleteWithConfirmButton,
  FunctionField,
} from 'react-admin'
import { useTranslate } from 'ra-core'
import * as React from 'react'
import { MyPagination } from '../../MyPagination'
import StatusChip from '../../components/StatusChip'

const ThematicListActions = () => {
  const translate = useTranslate()
  return (
    <TopToolbar>
      <CreateButton label={translate('surveys.actions.new_thematics')} />
    </TopToolbar>
  )
}

const ThematicList = props => {
  const translate = useTranslate()
  const { identity, loading: identityLoading } = useGetIdentity()
  if (identityLoading) return <>Loading...</>
  const thematicLabel = 'label.' + identity.country.toLowerCase()
  return (
    <List
      {...props}
      actions={<ThematicListActions />}
      bulkActionButtons={false}
      sort={{ field: 'id', order: 'DESC' }}
      pagination={<MyPagination />}
    >
      <Datagrid>
        <NumberField source="id" sortByOrder="DESC" />
        <TextField
          source={thematicLabel}
          label={translate('surveys.common.name')}
        />
        <TextField
          source="country"
          label={translate('surveys.common.country')}
        />
        <FunctionField
          label={translate('surveys.common.status')}
          render={record => (
            <StatusChip
              value={record.status}
              activeLabel={translate('surveys.common.active')}
              inactiveLabel={translate('surveys.common.desactive')}
            />
          )}
        />
        <EditButton />
        <DeleteWithConfirmButton cancel="Cancel" undoable={true} />
      </Datagrid>
    </List>
  )
}

export default ThematicList
